export enum headerDropdownItemsEnum {
  SETTINGS = 'Settings',
  MEMBERSHIP = 'Membership',
  SIGN_OUT = 'Sign out',
  UPGRADE = 'Upgrade'
}
